import React from "react"
import { Box, Button, Paper, Container, Typography } from "@material-ui/core"
import { useDispatch } from "react-redux"
import MaterialTable from "material-table"
import { toggleManageExpensesDialog } from "../../../../actions/billingDialogs"
import { updateExpenseListType } from "../../../../actions/super"
import { openSnackBar } from "../../../../actions/snack-bar"
import PropTypes from "prop-types"
import HoverText from "../../Common/HoverText/index"
import capitalizeFirstLetter from "../../../../utils/capitalizeFirstLetter"

const ExpensesListTable = ({
  expensesList = [],
  setExpensesList = () => {},
}) => {
  const dispatch = useDispatch()

  const editExpenseTypeDetails = dialogVals => {
    let updateData = { ...dialogVals }
    let expenseId = dialogVals.id
    delete updateData.tableData
    dispatch(updateExpenseListType(expenseId, dialogVals))
      .then(() => {
        setExpensesList(oldState => {
          return oldState.map(expense => {
            let newExpense = { ...expense }
            if (newExpense.id === expenseId) {
              return updateData
            } else {
              return newExpense
            }
          })
        })
        dispatch(openSnackBar({ message: "Expense Type Updated" }))
      })
      .catch(err => {
        console.log(err)
        dispatch(openSnackBar({ message: "Error Updating Expense " }))
      })
  }

  const handleEditDialog = rowData => {
    let dialogData = {
      chosenExpense: rowData,
      expenseFunc: editExpenseTypeDetails,
    }
    dispatch(toggleManageExpensesDialog(true, dialogData))
  }

  const columns = [
    {
      title: "id",
      field: "id",
      headerStyle: {
        width: "10%",
        maxWidth: "10%",
        padding: "5px 10px",
      },
      cellStyle: {
        width: "10%",
        maxWidth: "10%",
        maxHeight: "25px",
        height: "25px",
        padding: "5px 10px",
      },
    },
    {
      title: "Name",
      field: "name",
      headerStyle: {
        width: "10%",
        maxWidth: "10%",
        padding: "5px 10px",
      },
      cellStyle: {
        width: "10%",
        maxWidth: "10%",
        maxHeight: "25px",
        height: "25px",
        padding: "5px 10px",
      },
    },
    {
      title: "Default Description",
      field: "default_description",
      headerStyle: {
        width: "40%",
        maxWidth: "40%",
        padding: "5px 10px",
      },
      cellStyle: {
        width: "40%",
        maxWidth: "40%",
        maxHeight: "25px",
        height: "25px",
        padding: "5px 10px",
      },
      render: rowData => {
        return (
          <Box display="flex" justifyContent="flex-start">
            <HoverText data={rowData.default_description} size={100} />
          </Box>
        )
      },
    },
    {
      title: "Rate",
      field: "default_actual_rate",
      headerStyle: {
        width: "10%",
        maxWidth: "10%",
        padding: "5px 10px",
      },
      cellStyle: {
        width: "10%",
        maxWidth: "10%",
        maxHeight: "25px",
        height: "25px",
        padding: "5px 10px",
      },
      render: rowData => {
        return (
          <Box display="flex" justifyContent="flex-start">
            <Typography color="primary">
              {rowData.default_actual_rate ? rowData.default_actual_rate : 0}
            </Typography>
          </Box>
        )
      },
    },
    {
      title: "Markup Type",
      field: "is_percentage",
      headerStyle: {
        width: "10%",
        maxWidth: "10%",
        padding: "5px 10px",
      },
      cellStyle: {
        width: "10%",
        maxWidth: "10%",
        maxHeight: "25px",
        height: "25px",
        padding: "5px 10px",
      },
      render: rowData => {
        return (
          <Box display="flex" justifyContent="flex-start">
            <Typography color="primary">
              {rowData.default_is_percentage === 0 ? "$" : "%"}
            </Typography>
          </Box>
        )
      },
    },
    {
      title: "Client Default Value",
      field: "default_client_rate",
      headerStyle: {
        width: "10%",
        maxWidth: "10%",
        padding: "5px 10px",
      },
      cellStyle: {
        width: "10%",
        maxWidth: "10%",
        maxHeight: "25px",
        height: "25px",
        padding: "5px 10px",
      },
      render: rowData => {
        return (
          <Box display="flex" justifyContent="flex-start">
            <Typography color="primary">
              {rowData.default_client_value ? rowData.default_client_value : 0}
            </Typography>
          </Box>
        )
      },
    },
    {
      title: "Expense Type",
      field: "type",
      headerStyle: {
        width: "10%",
        maxWidth: "10%",
        padding: "5px 10px",
      },
      cellStyle: {
        width: "10%",
        maxWidth: "10%",
        maxHeight: "25px",
        height: "25px",
        padding: "5px 10px",
      },
      render: rowData => {
        return (
          <Box display="flex" justifyContent="flex-start">
            <Typography>
              {rowData.type ? capitalizeFirstLetter(rowData.type) : ""}
            </Typography>
          </Box>
        )
      },
    },

    {
      title: "",
      field: "",
      headerStyle: {
        width: "10%",
        maxWidth: "10%",
        padding: "5px 10px",
      },
      cellStyle: {
        width: "10%",
        maxWidth: "10%",
        maxHeight: "25px",
        height: "25px",
        padding: "5px 10px",
      },
      render: rowData => {
        return (
          <Button color="primary" onClick={() => handleEditDialog(rowData)}>
            Edit
          </Button>
        )
      },
    },
  ]

  return (
    <Container>
      <Box overflow="auto" flexGrow={1}>
        <MaterialTable
          // loading={loading}
          components={{
            Container: props => <Paper {...props} elevation={0} />,
          }}
          title=""
          columns={columns}
          options={{
            pageSizeOptions: [10, 25, 50],
            pageSize: 10,
            search: false,
            showTitle: false,
            toolbar: false,
            paging: true,
            tableLayout: "auto",
            rowStyle: (rowData, i) => ({
              backgroundColor: i % 2 !== 0 ? "#f2f2f2" : "#fff",
              height: "43px",
              whiteSpace: "nowrap",
              maxHeight: "49px",
              overflowWrap: "break-word",
            }),
            headerStyle: {
              height: "69px",
              color: "#9A9A9A",
              whiteSpace: "nowrap",
              font: "normal normal bold 13px/15px Helvetica",
              textTransform: "uppercase",
              opacity: 1,
              paddingRight: "25px",
            },
            style: { border: "none" },
          }}
          data={expensesList}
        />
      </Box>
    </Container>
  )
}

ExpensesListTable.propTypes = {
  expensesList: PropTypes.array,
  setExpensesList: PropTypes.func,
}

export default ExpensesListTable
